"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorDailyRoTaskReminder = void 0;
const typebox_1 = require("@sinclair/typebox");
const SwitchSchema = typebox_1.Type.Object({
    deliveryPo: typebox_1.Type.String(),
    pickupPo: typebox_1.Type.String(),
    address: typebox_1.Type.String(),
    deliveryDescription: typebox_1.Type.String(),
    pickupDescription: typebox_1.Type.String(),
    link: typebox_1.Type.Optional(typebox_1.Type.String()),
});
const DeliverySchema = typebox_1.Type.Object({
    deliveryPo: typebox_1.Type.String(),
    address: typebox_1.Type.String(),
    description: typebox_1.Type.String(),
    link: typebox_1.Type.Optional(typebox_1.Type.String()),
});
const PickupSchema = typebox_1.Type.Object({
    pickupPo: typebox_1.Type.String(),
    address: typebox_1.Type.String(),
    description: typebox_1.Type.String(),
    link: typebox_1.Type.Optional(typebox_1.Type.String()),
});
const DayTaskSchema = typebox_1.Type.Object({
    date: typebox_1.Type.String(),
    switches: typebox_1.Type.Array(SwitchSchema),
    deliveries: typebox_1.Type.Array(DeliverySchema),
    pickups: typebox_1.Type.Array(PickupSchema),
});
exports.VendorDailyRoTaskReminder = typebox_1.Type.Object({
    vendorName: typebox_1.Type.String(),
    vendorId: typebox_1.Type.String(),
    generatedAt: typebox_1.Type.String(),
    today: typebox_1.Type.Optional(DayTaskSchema),
    tomorrow: typebox_1.Type.Optional(DayTaskSchema),
});
//# sourceMappingURL=vendor-daily-ro-task-reminder.js.map